import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveTab,
  setCurrent,
} from "../../redux/features/questions/questionSlice";
import ObjContainer from "./ObjContainer/ObjContainer";
import Tabs from "./Tabs/Tabs";
import Tab from "./Tabs/Tabs";
import TheoryContainer from "./TheoryContainer/TheoryContainer";

const QuestionsContent = () => {
  const { list, activeTab, hasTheory, hasMultiChoice } = useSelector(
    (state) => state.questions
  );
  const dispatch = useDispatch();
  const handleTabChange = (tab) => {
    const firstTheory = list.findIndex(({ type }) => type === "theory");
    const firstTMulti = list.findIndex(({ type }) => type === "multichoice");
    if (tab !== activeTab) {
      if (tab === "multichoice" && firstTMulti >= 0) {
        dispatch(setCurrent(firstTMulti));
      }
      if (tab === "theory" && firstTheory >= 0) {
        dispatch(setCurrent(firstTheory));
      }
    }
    dispatch(setActiveTab(tab));
  };
  return (
    <div className="w-100">
      <Tabs changeTab={handleTabChange} activeKey={activeTab}>
        {hasMultiChoice && (
          <Tab label="multichoice">
            <ObjContainer />
          </Tab>
        )}
        {hasTheory && (
          <Tab label="theory">
            <TheoryContainer />
          </Tab>
        )}
      </Tabs>
    </div>
  );
};

export default QuestionsContent;
